module.exports = "/_next/static/images/join-discord-pt-br-ec7c399c36b1280c6653316571ff0493.png";